import { RootState } from 'redux/schemas';
import { MentorshipProgramCustomCommunication } from 'redux/schemas/models/mentorship-program-custom-communications';
import { createSelector } from 'reselect';

export const selectCustomCommunications = createSelector(
  (state: RootState) => state.models.mentorshipProgramCustomCommunications,
  (state, ids: number[]) => ids,
  (
    mentorshipProgramCustomCommunications: Record<
      number,
      MentorshipProgramCustomCommunication
    >,
    ids: number[]
  ) => ids.map((id) => mentorshipProgramCustomCommunications[id])
);

export const selectCustomCommunicationById =
  (communicationId: number) => (state: RootState) =>
    (communicationId &&
      state.models.mentorshipProgramCustomCommunications[communicationId]) ||
    null;

export const selectCustomCommunicationPreview = (state: RootState) =>
  state.app.mentoringProgram.customCommunication.preview;
